import * as types from '../../types/menu.types';

export default {
  namespaced: true,
  state: {
    menu: [],
    limit: 8,
  },
  getters: {
    // categorias: state => state.menu.slice(0, state.limit)
    categorias: state => state.menu,
  },
  mutations: {
    [types.MENU](state, payload) {
      state.menu = payload;
    },
  },
  actions: {
    menuHeader({ commit }, menu) {
      commit(types.MENU, menu);
    },
  },
};
